import type { CSSProperties } from 'react';
import { Colors } from 'styles';
import { openSironaSupportChat, SIRONA_SUPPORT_CHAT_URL } from './openSironaSupportChat';

interface SironaSupportLinkProps {
  color?: CSSProperties['color'];
}

export const SironaSupportLink = ({ color = Colors.blue4 }: SironaSupportLinkProps) => (
  <a
    href={SIRONA_SUPPORT_CHAT_URL}
    target="_blank"
    rel="noopener noreferrer"
    style={{
      color,
      cursor: 'pointer',
      font: 'inherit',
      textDecoration: 'underline',
    }}
    onClick={(event) => {
      event.preventDefault();
      openSironaSupportChat();
    }}
  >
    Sirona Support
  </a>
);
